import React from 'react';

import { Link } from 'react-router-dom';

import { Box, Typography, useTheme } from '@mui/material';

import { useTranslation } from 'react-i18next';

import type { ProductSearch } from '../../../models/ProductSearch';

export const CollectionProductTitle: React.FC<{
    product: ProductSearch;
    collectionHandle?: string;
}> = ({ product, collectionHandle }) => {
    const theme = useTheme();

    const { t } = useTranslation('collection', {
        keyPrefix: 'COLLECTIONS',
    });
    const handle = collectionHandle
        ? '/collections/' + collectionHandle + '/products/' + product.handle
        : '/products/' + product.handle;

    return (
        <Box flexWrap="wrap" paddingY={1}>
            <Link to={handle} target="_blank">
                <Typography
                    variant="subtitle2"
                    color={theme.palette.text.primary}
                    style={{ lineBreak: 'anywhere' }}
                >
                    {product.title}
                </Typography>
            </Link>

            <Typography
                variant="caption"
                color="#999"
                style={{ textTransform: 'uppercase', lineBreak: 'anywhere' }}
            >
                {t('PRODUCT.SKU')}: {product.sku}
            </Typography>
        </Box>
    );
};
